import React, { useState } from "react";
import { Modal } from "reactstrap";
import { useTranslation } from "react-i18next";

export const BtnDownload = ({
  apiUrl = "https://jc-innovation.com/guardar_email.php",
  // Ruta base donde están tus PDFs; cámbiala si es necesario
  basePdfPath = "/",
  ...args
}) => {
  const { t, i18n } = useTranslation();

  const [modal, setModal] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const toggle = () => {
    if (modal) {
      setEmail("");
      setSent(false);
      setError("");
      setLoading(false);
    }
    setModal(!modal);
  };

  // Map de idioma -> nombre de archivo
  const getPdfUrlByLang = () => {
    const lang = (i18n.language || "es").toLowerCase();
    const short = lang.slice(0, 2); // "es", "en", etc.

    const files = {
      es: "JC-Innovation-ServiciosBrochure-ES.pdf",
      en: "JC-Innovation-ServiciosBrochure-EN.pdf",
    };

    const filename = files[short] || files.en; // fallback a EN si no es ES/EN
    return basePdfPath + filename;
  };

  const isValidEmail = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val.trim());

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!isValidEmail(email)) {
      setError("Por favor ingresa un correo válido.");
      return;
    }

    try {
      setLoading(true);

      const res = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data?.message || "No se pudo guardar el correo.");

      // Éxito: mostramos el bloque de confirmación y descargamos el PDF correcto
      setSent(true);
      const pdfUrl = getPdfUrlByLang();
      window.open(pdfUrl, "_blank", "noopener,noreferrer");
    } catch (err) {
      setError(err.message || "Ocurrió un error al enviar.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button className="btn btn-brochure" onClick={toggle}>
        <i className="fa-solid fa-download" />
        <span>{t("PORTAFOLIO DE SERVICIOS")}</span>
      </button>

      <Modal
        centered
        size="lg"
        isOpen={modal}
        toggle={toggle}
        {...args}
        className="wrapper_modal_portafolio"
      >
        <div className="modal_portafolio">
          <span className="btnclose" onClick={toggle}>
            <i className="fa-solid fa-xmark"></i>
          </span>

          {!sent ? (
            <div>
              <h5 className="ttls fw_600 c_marin mb-3 text-center">
                {t("¡Estas a solo un paso! conoce nuestros servicios y paquetes para tu próximo evento!")}
              </h5>

              <form className="content_modal_portafolio" onSubmit={handleSubmit}>
                <div className="input-group input-group-lg">
                  <span className="input-group-text" id="basic-addon1">
                    <i className="fa-regular fa-envelope"></i>
                  </span>
                  <input
                    type="email"
                    className="form-control"
                    placeholder={t("Compártenos tu correo electrónico")}
                    aria-label="Compártenos tu correo electrónico"
                    aria-describedby="button-addon2"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={loading}
                  />
                  <button className="btn trans" type="submit" id="button-addon2" disabled={loading}>
                    <i className="fa-regular fa-circle-down"></i>{" "}
                    <span>
                      <span className="fw_900">{loading ? t("Enviando...") : t("Descargar")}</span>{" "}
                      {t("portafolio")}
                    </span>
                  </button>
                </div>

                {error && <div className="mt-3 alert alert-danger py-2 mb-0">{error}</div>}
              </form>
            </div>
          ) : (
            <div className="mnj_successfull text-center p-3">
              <p className="mnj_a mb-2">
                <i className="fa-regular fa-circle-check"></i>{" "}
                <span>Portafolio descargado</span>
              </p>
              <p className="mnj_b mb-2">
                <span>Ya diste el primer paso.</span>
              </p>
              <p className="mnj_c mb-0">
                Tu evento merece ser único y nosotros sabemos cómo lograrlo. Escríbenos y hagámoslo posible.
              </p>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};
